export const tile3DLayerProps = {
  id: 'tile-3D-layer',
  pickable: false,
  opacity: 0.5,
};
